import React from 'react'
import './AffiliatePartnerRequestComponent.css'
const AffiliatePartnerRequestComponent = () => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      AffiliatePartnerRequestComponent
    </div>
  )
}

export default AffiliatePartnerRequestComponent
